import { Directive, HostListener, Input, OnInit, OnDestroy } from "@angular/core";

@Directive({
    selector: "[tigClickOutside]"
})
export class ClickOutsideDirective implements OnInit, OnDestroy {

    @Input("tigClickOutside") public offClickHandler: any;

    @HostListener("click", ["$event"]) public onClick($event: MouseEvent): void {
        $event.stopPropagation();
    }

    public ngOnInit(): any {
        setTimeout(() => {
            if (typeof document !== "undefined") {
                document.addEventListener("click", this.offClickHandler);
            }
        }, 0);
    }

    public ngOnDestroy(): any {
        if (typeof document !== "undefined") {
            document.removeEventListener("click", this.offClickHandler);
        }
    }
}